/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { changeModal } from "../../Redux/Actions";

/* 🔧 UTILS */
import { createStep } from "./index";

export const profileSteps = (t) => [
    createStep({
        selector: '#confirm-email',
        stepNumber: 1,
        titleKey: t("tour.profile.confirm-email.title"),
        textKey: t("tour.profile.confirm-email.text"),
    }),
    createStep({
        selector: '.personal-data',
        stepNumber: 2,
        titleKey: t("tour.profile.personal-data.title"),
        textKey: t("tour.profile.personal-data.text"),
    }),
    createStep({
        selector: '#parameterisation',
        stepNumber: 3,
        titleKey: t("tour.profile.parameterisation.title"),
        textKey: t("tour.profile.parameterisation.text"),
    }),
    createStep({
        selector: '#security-settings',
        stepNumber: 2,
        titleKey: t("tour.profile.security-settings.title"),
        textKey: t("tour.profile.security-settings.text"),
    }),
    createStep({
        selector: '#email-card',
        stepNumber: 3,
        titleKey: t("tour.profile.email-card.title"),
        textKey: t("tour.profile.email-card.text"),
    }),
    createStep({
        selector: '#two-factor-auth-card',
        stepNumber: 4,
        titleKey: t("tour.profile.two-factor-auth-card.title"),
        textKey: t("tour.profile.two-factor-auth-card.text"),
    }),
    createStep({
        selector: '#codes',
        stepNumber: 5,
        titleKey: t("tour.profile.codes.title"),
        textKey: t("tour.profile.codes.text"),
    }),
    createStep({
        selector: '#qr-code',
        stepNumber: 6,
        titleKey: t("tour.profile.qr-code.title"),
        textKey: t("tour.profile.qr-code.text"),
    }),
    createStep({
        selector: '#measurement-units',
        stepNumber: 7,
        titleKey: t("tour.profile.measurement-units.title"),
        textKey: t("tour.profile.measurement-units.text"),
    }),
    createStep({
        selector: '#select-unit',
        stepNumber: 8,
        titleKey: t("tour.profile.select-unit.title"),
        textKey: t("tour.profile.select-unit.text"),
    }),
]


export const handleProfilePrevStep = (currentStep, setCurrentStep) => {
    
    const stepActions = {
        2: () => {
            const securitySettingsButton = document.querySelector('#personal-data');
            securitySettingsButton && securitySettingsButton.click();
            setCurrentStep(1);
        },
        4: () => {
            store.dispatch(changeModal(null));
            setCurrentStep(3);
        },
        5: () => {
            const securitySettingsButton = document.querySelector('#two-factor-auth-card');
            securitySettingsButton && securitySettingsButton.click();
            setCurrentStep(4);
        },
        6: () => {
            store.dispatch(changeModal('f2aModal'));
            // document.querySelector('#two-factor-auth-modal').scrollIntoView({ behavior: "smooth", block: "start" });
            setCurrentStep(5);
        },
        7: () => {
            const securitySettingsButton = document.querySelector('#security-settings');
            securitySettingsButton && securitySettingsButton.click();
            setCurrentStep(6);
        },

    };
  
    if (stepActions[currentStep]) {
        stepActions[currentStep]();
    } else {
        setCurrentStep(currentStep - 1);
    }
 };

export const handleProfileNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
    const stepActions = {
        1: () => {      
            const securitySettingsButton = document.querySelector('#security-settings');
            securitySettingsButton && securitySettingsButton.click();
            setCurrentStep(2);
        },
        3: () => {
            store.dispatch(changeModal('f2aModal'));
            setCurrentStep(4);
        },
        5: () => {
            store.dispatch(changeModal(null));
            setCurrentStep(6);
        },
        6: () => {
            const securitySettingsButton = document.querySelector('#measurement-units');
            securitySettingsButton && securitySettingsButton.click();
            setCurrentStep(7);
        },
        7:() => {
             const securitySettingsButton = document.querySelector('#personal-data');
            securitySettingsButton && securitySettingsButton.click();
            store.dispatch(changeModal(null));
            setIsOpen(false);
            setCurrentStep(0);
        }
    };

    if (stepActions[currentStep]) {
        stepActions[currentStep]();
    } else {
        setCurrentStep(currentStep + 1);
    }
};
